export default {
    props: {
        messagesMeasures: {
            type: String,
            default: undefined,
            kComposite: 'messages.measures'
        }, 
        messagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'messages.columns'
        }, 
        messagesRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.rows'
        }, 
        messagesMeasuresLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.measuresLabel'
        }, 
        messagesRowsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.rowsLabel'
        }, 
        messagesColumnsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.columnsLabel'
        }, 
        messagesFieldsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldsLabel'
        }, 
        messagesFieldMenuInfo: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.info'
        }, 
        messagesFieldMenuSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortAscending'
        }, 
        messagesFieldMenuSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortDescending'
        }, 
        messagesFieldMenuFilterFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filterFields'
        }, 
        messagesFieldMenuFilter: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filter'
        }, 
        messagesFieldMenuInclude: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.include'
        }, 
        messagesFieldMenuTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.title'
        }, 
        messagesFieldMenuClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.clear'
        }, 
        messagesFieldMenuOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.ok'
        }, 
        messagesFieldMenuCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.cancel'
        }, 
        messagesFieldMenuOperatorsContains: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.contains'
        }, 
        messagesFieldMenuOperatorsDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.doesnotcontain'
        }, 
        messagesFieldMenuOperatorsStartswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.startswith'
        }, 
        messagesFieldMenuOperatorsEndswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.endswith'
        }, 
        messagesFieldMenuOperatorsEq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.eq'
        }, 
        messagesFieldMenuOperatorsNeq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.neq'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotConfigurator/Messages.js